/**
 * ユーザー情報
 */

var User = User || {};

/**
 * ユーザー情報取得
 */
User.getUser = function() {
    var defer = $.Deferred();
    var ajax = $.ajax({
        url: '/service/header.json',
        method: 'GET',
        success: defer.resolve,
        error: defer.reject
    });

    return defer.promise();
}
